import React, { useState } from "react";
import mastercourseapi from '../api/mastercourse';
import loginapi from '../api/login';
import { useNavigate } from "react-router-dom";

const Course = ({ course,slno,onTitleSave,onCreditSave}) => {
  const navigate = useNavigate();
  const [title, setTitle] = useState(course.title);
    const [credit, setCredit] = useState(course.credit);
 const handleTitleBlur = () => {
    if (title !== course.title) {
      onTitleSave(course.code, title);
    }
  };

  const handleCreditBlur = () => {
    if (credit !== course.credit) {
      onCreditSave(course.code, credit);
    }
  };

  return (
    <div className="w-full border rounded-lg shadow-md p-2 mt-2 mb-2 bg-white w-full">
    {/* First Row */}
    <div className="grid grid-cols-[1fr] gap-4 border-b pb-2">
      <div className="flex ">
      <p className="text-xs text-gray-500 text-left w-9">{slno}</p>
      <input className="font-semibold text-xs text-gray-900 text-lleft w-full p-1 border-red-800 border-b"  value={title}
       onChange={(e) => setTitle(e.target.value)}
        onBlur={handleTitleBlur}/>
      </div>
    </div>

    {/* Second Row */}
    <div className="grid grid-cols-[2fr_.5fr_2fr_2fr_2fr] gap-4 pt-2 pb-2 text-center text-gray-700">

      <div className="flex flex-col p-1 border-b border-blue-500">
        <p className="text-gray-500 text-xs">Code</p>
        <p className="font-semibold text-xs text-gray-900">{course.code}</p>
      </div>

      <div className="flex flex-col p-1 border-b border-blue-500">
        <p className="text-gray-500 text-xs">Crdt</p>
        <input className="font-semibold text-xs text-gray-900 border-red-800 border-b p-1"
        value={credit}
       onChange={(e) => setCredit(e.target.value)}
        onBlur={handleCreditBlur}
        />
      </div>

      <div className="flex border-b p-1 border-blue-500">
        <div className="flex-1  flex flex-col">
          <p className="text-gray-500 text-xs">I_TTL</p>
          <p className="font-semibold text-xs text-gray-900">{course.midTermTotal}</p>
        </div>
        <div className="flex-1 flex flex-col">
          <p className="text-gray-500 text-xs">I_PASS</p>
          <p className="font-semibold text-xs text-gray-900">{course.midTermPass}</p>
        </div>
      </div>


      <div className="flex border-b p-1 border-blue-500">
        <div className="flex-1 flex flex-col">
          <p className="text-gray-500 text-xs">P_TTL</p>
          <p className="font-semibold text-xs text-gray-900">{course.practicalTotal}</p>
        </div>
        <div className="flex-1  flex flex-col">
          <p className="text-gray-500 text-xs">P_PASS</p>
          <p className="font-semibold text-xs text-gray-900">{course.practicalPass}</p>
        </div>
      </div>


      <div className="flex border-b p-1 border-blue-500">
        <div className="flex-1  flex flex-col">
          <p className="text-gray-500 text-xs">E_TTL</p>
          <p className="font-semibold text-xs text-gray-900">{course.endTermTotal}</p>
        </div>
        <div className="flex-1 flex flex-col">
          <p className="text-gray-500 text-xs">E_PASS</p>
          <p className="font-semibold text-xs text-gray-900">{course.endTermPass}</p>
        </div>
      </div>
    </div>
  </div>

  );
};

export default Course;
